module.exports = __webpack_public_path__ + "static/media/hand-rock.41708601.svg";